<datex-grid #$gridComponent *ngIf="initialized " [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="delete_record" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    matTooltipClass="datex-control-tooltip"
                    (click)="on_delete_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>


  <ng-container gridColumnDef="charge_type">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.charge_type.displayControl.styles.style"
          [ngClass]="row.cells.charge_type.displayControl.styles.classes"
          [matTooltip]="row.cells.charge_type.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.charge_type.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Invoices-freight_billing_charge_types_selector_single 
        data-cy="selector"
        [type]="row.cells.charge_type.editControl.type"
        [formControl]="row.formGroup.controls['charge_type_edit']"
        (displayTextChange)="row.cells.charge_type.editControl.displayText=$event"
        [placeholder]="row.cells.charge_type.editControl.placeholder"
        [styles]="row.cells.charge_type.editControl.styles"
        [tooltip]="row.cells.charge_type.editControl.tooltip"
    >
    </Invoices-freight_billing_charge_types_selector_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="charge_amount">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.charge_amount.displayControl.styles.style"
          [ngClass]="row.cells.charge_amount.displayControl.styles.classes"
          [matTooltip]="row.cells.charge_amount.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.charge_amount.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['charge_amount_edit']"
            matInput
            numberBox
            [format]="row.cells.charge_amount.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.charge_amount.editControl.readOnly || row.cells.charge_amount.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.charge_amount.editControl.placeholder}}"
            [ngStyle]="row.cells.charge_amount.editControl.styles.style"
            [ngClass]="row.cells.charge_amount.editControl.styles.classes"
            [matTooltip]="row.cells.charge_amount.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="pallet_range_from">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.pallet_range_from.displayControl.styles.style"
          [ngClass]="row.cells.pallet_range_from.displayControl.styles.classes"
          [matTooltip]="row.cells.pallet_range_from.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.pallet_range_from.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['pallet_range_from_edit']"
            matInput
            numberBox
            [format]="row.cells.pallet_range_from.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.pallet_range_from.editControl.readOnly || row.cells.pallet_range_from.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.pallet_range_from.editControl.placeholder}}"
            [ngStyle]="row.cells.pallet_range_from.editControl.styles.style"
            [ngClass]="row.cells.pallet_range_from.editControl.styles.classes"
            [matTooltip]="row.cells.pallet_range_from.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="pallet_range_to">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.pallet_range_to.displayControl.styles.style"
          [ngClass]="row.cells.pallet_range_to.displayControl.styles.classes"
          [matTooltip]="row.cells.pallet_range_to.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.pallet_range_to.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="numberBox" [formControl]="row.formGroup.controls['pallet_range_to_edit']"
            matInput
            numberBox
            [format]="row.cells.pallet_range_to.editControl.format"
            autocomplete="off"
            spellcheck="false"
            class="datex-numberbox {{ (row.cells.pallet_range_to.editControl.readOnly || row.cells.pallet_range_to.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.pallet_range_to.editControl.placeholder}}"
            [ngStyle]="row.cells.pallet_range_to.editControl.styles.style"
            [ngClass]="row.cells.pallet_range_to.editControl.styles.classes"
            [matTooltip]="row.cells.pallet_range_to.editControl.tooltip"
            matTooltipClass="datex-control-tooltip">
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
